import { Component } from '@angular/core';
import { NavigationProfilerService } from './shared/service/navigation-profiler.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'multikart-backend';
  constructor(_navProfiler: NavigationProfilerService) {
    // iOS/Safari: desactivar scrollRestoration auto para evitar reflows largos en navegación
    try {
      const ua = navigator.userAgent;
      const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua);
      if (isSafari && 'scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
    } catch {}
  }
}
